// extracted by mini-css-extract-plugin
export var appRibbon = "ObApJ";
export var appRibbonBleedThrough = "P4DmP";